import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";
gsap.registerPlugin(ScrollTrigger, SplitText);

const hpHero = document.querySelector(".hp-hero");
if (hpHero) {
  const hpTextSlider = hpHero.querySelector(".hp-text-slider");
 
  if (hpTextSlider) {
    console.log("hp text slider is ready!");
    let sliderPromise = new Promise(function (sliderResolve) {
      const slider = tns({
        container: hpTextSlider,
        items: 1,
        loop: true,
        autoplay: true,
        speed: 400,
        duration: 400,
        autoplayDuration: 3000,
        axis: "vertical",
        autoplayButtonOutput: false,
        controls: false,
        nav: false,
      });
      sliderResolve(slider.getInfo().container);
    });
    sliderPromise.then(function (sliderContainer) {
      // .. code after the slider has been built up
      console.log("hp hero slider is ready!");
      const hiddenSlides = hpTextSlider.querySelectorAll(".pre-tns-hidden");
      hiddenSlides.forEach((slide, index) => {
        slide.classList.remove("pre-tns-hidden");
      });
    });
  }
}
